import getConfig from "next/config";
import { Field, Form, FormSpy } from "react-final-form";

import InputText from "@components/Form/InputText";
import Select from "@components/Form/Select";

const {
  publicRuntimeConfig: {
    content: { websiteTitle },
  },
} = getConfig();

const StoresFilters = ({ regions, onFiltersChange }) => (
  <Form
    onSubmit={() => null}
    initialValues={{ regionId: "", storeSearch: "" }}
    render={() => (
      <form
        className="flex flex-col md:flex-row gap-[20px] md:max-w-[80%]"
        onSubmit={(event) => event.preventDefault()}
      >
        <FormSpy onChange={({ values }) => onFiltersChange(values)} />

        <div className="flex flex-col flex-grow">
          <Field
            label={`Magazinele ${websiteTitle} din`}
            name="regionId"
            component={Select}
            placeholder="Toate regiunile"
            inputClassName="!max-w-full"
          >
            <option value="">Toate regiunile</option>

            {regions?.length &&
              regions.map((region) => (
                <option key={region.id} value={region.id}>
                  {region.name}
                </option>
              ))}
          </Field>
        </div>

        <div className="flex flex-col flex-grow">
          <Field
            label="Cauta magazin"
            name="storeSearch"
            component={InputText}
            placeholder="Cauta magazin..."
            inputClassName="!max-w-full"
          />
        </div>
      </form>
    )}
  />
);

export default StoresFilters;
